import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userKey: '',
    style: 'styleC' // styleA:默认主题 styleB：红色主题 styleC：黑色主题
  },
  mutations: {
    // 存储token
    SET_USERTOKEN(state, data) {
      state.userKey = data
    }
  },
  actions: {
  },
  modules: {
  }
})
